import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { GetBannerRequest } from '../models';
import { settingActions } from './SettingSlice';
import { HTTP_RESPONSE_STATUS } from 'setup/constants/Http';
import SettingApi from './SettingApi';
import { ToastDefaultConfig } from 'setup/toast/ToastConfig';

function* fetchBannerList(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response = yield call(SettingApi.getBanner);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(settingActions.fetchBannerListSuccess(response.data));
    } else {
      toast.error(response.message || 'Failed to fetch banner list', ToastDefaultConfig());
      yield put(settingActions.fetchBannerListFailed(response.message || 'Failed to fetch banner list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch banner list', ToastDefaultConfig());
    yield put(settingActions.fetchBannerListFailed(error.message || 'Failed to fetch banner list'));
  }
}

function* fetchListGroup(action: PayloadAction<GetBannerRequest>): Generator<any, void, any> {
  try {
    const response = yield call(SettingApi.getListGroup, action.payload);
    console.log("response", response);
    
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(settingActions.fetchListGroupSuccess(response.data));
    } else {
      toast.error(response.message || 'Failed to fetch list group', ToastDefaultConfig());
      yield put(settingActions.fetchListGroupFailed(response.message || 'Failed to fetch list group'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch list group', ToastDefaultConfig());
    yield put(settingActions.fetchListGroupFailed(error.message || 'Failed to fetch list group'));
  }
}

function* fetchPWAAboutUsData(): Generator<any, void, any> {
  try {
    const response = yield call(SettingApi.getPWAAboutUs);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(settingActions.fetchAboutUsDataSuccess(response.data));
    } else {
      toast.error(response.message || 'Failed to fetch list group', ToastDefaultConfig());
      yield put(settingActions.fetchAboutUsDataFailed(response.message || 'Failed to fetch list group'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch list group', ToastDefaultConfig());
    yield put(settingActions.fetchAboutUsDataFailed(error.message || 'Failed to fetch list group'));
  }
}

function* fetchPWATernAndConditionData(): Generator<any, void, any> {
  try {
    const response = yield call(SettingApi.getPWATermAndCondition);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      yield put(settingActions.fetchTermAndConditionDataSuccess(response.data));
    } else {
      toast.error(response.message || 'Failed to fetch list group', ToastDefaultConfig());
      yield put(settingActions.fetchTermAndConditionDataFailed(response.message || 'Failed to fetch list group'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch list group', ToastDefaultConfig());
    yield put(settingActions.fetchTermAndConditionDataFailed(error.message || 'Failed to fetch list group'));
  }
}

export function* settingSaga() {
  yield takeLatest(settingActions.fetchBannerListStart.type, fetchBannerList);
  yield takeLatest(settingActions.fetchListGroupStart.type, fetchListGroup);
  yield takeLatest(settingActions.fetchAboutUsDataStart.type, fetchPWAAboutUsData);
  yield takeLatest(settingActions.fetchTermAndConditionDataStart.type, fetchPWATernAndConditionData);
}

export default settingSaga;

